/* WashPair · Zarif: a free-gliding step gallery.
   Flick it with a finger or the mouse: the whole row of photos glides on, slows down and stops by itself.
   Touch or click while it glides and it stops right there. No snapping to a card.
   Video cards play muted on a loop while they are on screen and pause when they leave it;
   the Pause/Play button lets the visitor stop one. Arrows step one card at a time. */
(() => {
  if (window.__wpLux) return; window.__wpLux = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const two = n => String(n).padStart(2, '0');
  const FRICTION = 0.9975; /* per millisecond: higher glides further */

  const init = sec => {
    const track = sec.querySelector('.wp-lx-track');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    const cards = [...track.querySelectorAll('.wp-lx-card')], n = cards.length; if (!n) return;
    const num = sec.querySelector('.wp-lx-count b'), bar = sec.querySelector('.wp-lx-bar i');
    const prevs = [...sec.querySelectorAll('[data-lx=prev]')], nexts = [...sec.querySelectorAll('[data-lx=next]')];
    const padL = () => parseFloat(getComputedStyle(track).paddingLeft) || 0;
    const maxX = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const first = () => {
      const x = track.scrollLeft + padL(); let best = 0, bd = Infinity;
      cards.forEach((c, i) => { const d = Math.abs(c.offsetLeft - x); if (d < bd) { bd = d; best = i; } });
      return best;
    };

    /* mouse glide (fingers use the phone's own glide) */
    let glide = 0;
    const stopGlide = () => { if (glide) { cancelAnimationFrame(glide); glide = 0; } };
    const startGlide = v => {
      stopGlide(); if (reduced || Math.abs(v) < 0.05) return;
      let last = performance.now();
      const step = now => {
        const dt = Math.min(48, now - last); last = now;
        const before = track.scrollLeft;
        track.scrollLeft = before + v * dt;
        v *= Math.pow(FRICTION, dt);
        if (Math.abs(v) < 0.02 || track.scrollLeft === before) { glide = 0; return; }
        glide = requestAnimationFrame(step);
      };
      glide = requestAnimationFrame(step);
    };

    const go = i => {
      stopGlide();
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: Math.min(maxX(), Math.max(0, cards[i].offsetLeft - padL())), behavior: reduced ? 'auto' : 'smooth' });
    };

    let raf = 0;
    const update = () => {
      raf = 0;
      const x = track.scrollLeft, atEnd = maxX() - x < 2, i = atEnd ? n - 1 : first();
      if (num) num.textContent = two(i + 1);
      prevs.forEach(b => { b.disabled = x < 2; });
      nexts.forEach(b => { b.disabled = atEnd; });
      if (bar) bar.style.transform = `scaleX(${track.scrollWidth ? Math.min(1, (x + track.clientWidth) / track.scrollWidth).toFixed(4) : 1})`;
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(update); };
    track.addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue, { passive: true });
    prevs.forEach(b => b.addEventListener('click', () => go(first() - 1)));
    nexts.forEach(b => b.addEventListener('click', () => go(first() + 1)));
    track.addEventListener('wheel', stopGlide, { passive: true });
    track.addEventListener('touchstart', stopGlide, { passive: true });

    /* a tap on a card that is cut off at the edge brings it into view */
    cards.forEach(c => c.addEventListener('click', e => {
      if (e.target.closest('.wp-lx-play, video')) return;
      const r = c.getBoundingClientRect(), t = track.getBoundingClientRect();
      if (r.right > t.right + 1) go(first() + 1);
      else if (r.left < t.left - 1) go(first() - 1);
    }));

    /* mouse drag: the row follows the mouse, then glides on after you let go */
    let pid = null, sx = 0, sl = 0, dragged = false, wasGliding = false, samples = [];
    track.addEventListener('pointerdown', e => {
      wasGliding = !!glide; stopGlide();
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      pid = e.pointerId; dragged = false; sx = e.clientX; sl = track.scrollLeft;
      samples = [{ t: performance.now(), x: e.clientX }];
    });
    track.addEventListener('pointermove', e => {
      if (e.pointerId !== pid) return;
      const dx = e.clientX - sx;
      if (!dragged) {
        if (Math.abs(dx) < 5) return;
        dragged = true; track.classList.add('is-drag');
        try { track.setPointerCapture(pid); } catch (err) { /* keep going without capture */ }
      }
      e.preventDefault();
      track.scrollLeft = sl - dx;
      const now = performance.now();
      samples.push({ t: now, x: e.clientX });
      while (samples.length > 2 && now - samples[0].t > 90) samples.shift();
    });
    const release = e => {
      if (pid === null || (e && e.pointerId !== pid)) return;
      try { track.releasePointerCapture(pid); } catch (err) { /* not captured */ }
      pid = null; track.classList.remove('is-drag');
      if (!dragged) return;
      const a = samples[0], b = samples[samples.length - 1], dt = b.t - a.t;
      if (dt > 0 && performance.now() - b.t < 60) startGlide(-(b.x - a.x) / dt);
      setTimeout(() => { dragged = false; }, 0);
    };
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('click', e => { if (dragged || wasGliding) { e.preventDefault(); e.stopPropagation(); wasGliding = false; } }, true);
    track.addEventListener('dragstart', e => e.preventDefault());

    /* videos: play muted on a loop while on screen, pause when off screen; the button pauses or resumes one */
    const vids = [...track.querySelectorAll('.wp-lx-fig')].map(fig => {
      const btn = fig.querySelector('.wp-lx-play'); if (!btn) return null;
      const v = document.createElement('video');
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.autoplay = false; v.preload = 'none';
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      const img = fig.querySelector('img'); if (img) v.poster = img.currentSrc || img.src;
      v.style.background = 'transparent'; v.style.opacity = '0'; v.style.transition = 'opacity .4s ease';
      v.addEventListener('playing', () => { v.style.opacity = '1'; });
      fig.insertBefore(v, btn);
      return { fig, btn, v, seen: false, held: false };
    }).filter(Boolean);
    const setBtn = (o, on) => {
      o.fig.classList.toggle('is-playing', on);
      const s = o.btn.querySelector('span'); if (s) s.textContent = on ? 'Pause' : 'Play';
      o.btn.setAttribute('aria-label', (on ? 'Pause' : 'Play') + ' video: ' + (o.btn.dataset.title || ''));
    };
    const play = o => {
      if (!o.v.getAttribute('src')) { o.v.src = o.btn.dataset.src; o.v.preload = 'auto'; }
      const p = o.v.play(); setBtn(o, true);
      if (p && p.catch) p.catch(() => setBtn(o, false));
    };
    const pause = o => { if (!o.v.paused) o.v.pause(); setBtn(o, false); };
    const sync = o => { if (o.seen && !o.held && !reduced) play(o); else pause(o); };
    vids.forEach(o => {
      setBtn(o, false);
      const toggle = e => { e.stopPropagation(); if (dragged) return; o.held = !o.v.paused; if (o.held) pause(o); else play(o); };
      o.btn.addEventListener('click', toggle);
      o.v.addEventListener('click', toggle);
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        const o = vids.find(x => x.fig === e.target); if (!o) return;
        const seen = e.isIntersecting && e.intersectionRatio >= 0.5;
        if (seen === o.seen) return;
        o.seen = seen; sync(o);
      }), { threshold: [0, 0.5, 1] });
      vids.forEach(o => io.observe(o.fig));
    } else { vids.forEach(o => { o.seen = true; sync(o); }); }
    document.addEventListener('visibilitychange', () => vids.forEach(o => { if (document.hidden) { if (!o.v.paused) o.v.pause(); } else sync(o); }));
    update();
  };

  const boot = () => document.querySelectorAll('[data-wp-lx-steps]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
